<template>
  <div>

    <a-modal v-model:visible="visible" title="预约详情" @ok="handleOk" okText="新建" cancelText="取消" :afterClose="closeModal" :footer="false">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">

        <a-form-item label="客户电话">
          {{data?.customer?.mobile}}
        </a-form-item>

        <a-form-item label="客户名称">
          {{data?.customer?.name}}
        </a-form-item>

        <a-form-item label="医生">
          {{data?.doctorName}}
        </a-form-item>

        <a-form-item label="预约日期">
          {{data?.date}}
        </a-form-item>

        <a-form-item label="预约时间段">
          {{data?.period}}
        </a-form-item>

        <a-form-item label="预约门店">
          {{data?.club?.name}}
        </a-form-item>

        <a-form-item label="状态">
          {{data?.tcmStatus}}
        </a-form-item>

        <a-form-item label="预约来源">
          {{data?.appointingApp}}
        </a-form-item>

        <a-form-item label="费用类型">
          {{data?.feeType}}
        </a-form-item>

        <a-form-item label="客户来源">
          {{data?.customer?.sdmSource?.clubName}}
        </a-form-item>

        <div v-if="data?.tcmStatus=='未开始'||data?.tcmStatus=='候诊中'" style="text-align: center; margin-top:20px;">
          <a-popconfirm title="是否确认取消预约" @confirm="DetelteAppointment" okText="确认" cancelText="取消">
            <a-button type="primary">取消预约</a-button>
          </a-popconfirm>
        </div>
      </a-form>
    </a-modal>
  </div>
  <addCustomer v-model="visible2" @selectCustomer="selectCustomer" />
</template>

<script>
import { reactive } from "vue";
import { AppointmentDetail, DetelteAppointment } from "/src/api/businessManage/appointment.js";
import addCustomer from '/src/components/todayConsultation/addCustomer.vue';
export default {
  components: {
    addCustomer
  },
  data() {
    return {
      visible: this.modelValue,
      visible2: false,
      data: {
      },
      labelCol: {
        span: 6,
      },
      disabledDate: undefined,
      wrapperCol: {
        span: 14,
      },
    };
  },
  emits: ['update:modelValue'],
  created() {

  },
  mounted() {
    this.init()
  },
  activated() {
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: String,
      default: null,
    }
  },
  computed: {
    medicineList() {
      const list = this.$store.state.medicineList;
      if (!this.medicineFilter) {
        return list.slice(0, 200);
      }
      return list.filter(item => item.name?.toLowerCase().includes(this.medicineFilter) || item.nameInitial?.toLowerCase().includes(this.medicineFilter)).slice(0, 200);
    }
  },
  methods: {
    init() {
      this.getDatail()
    },
    async getDatail() {
      let res = await AppointmentDetail({ uuid: this.uuid, includeClub: true, includeCustomerSource: true, includeCustomer: true });
      console.log(res);

      if (res.errCode == 0) {
        this.data = res.data
      }
    },
    filter() {
      return true
    },
    async DetelteAppointment() {
      let res = await DetelteAppointment({ uuid: this.uuid });
      if (res.errCode == 0) {
        this.$message.success('取消成功')
        this.closeModal()
      }
    },
    closeModal() {
      this.$emit('update:modelValue', false);
    },

  },
  watch: {
    modelValue(val) {
      this.visible = val
    },
    uuid(val) {
      this.init()
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
.flex {
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>
